import React from 'react';
import { X } from '@fabric-ui/icons';
import { emptyObject } from '@fabric-ui/utils';
import { Theme } from '@mui/material';
import { AvButton, ButtonKinds } from './';

const clearIcon = <X style={{ width: 20, height: 20 }} />;

export function ClearButton({ onClick, sx = emptyObject }: React.ComponentProps<typeof AvButton>) {
  return (
    <AvButton
      kind={ButtonKinds.ICON}
      key="clear"
      tabIndex={-1}
      aria-label="Clear"
      onClick={onClick}
      sx={{ color: (theme: Theme) => theme.palette.colors.neutrals[500], ...sx }}>
      {clearIcon}
    </AvButton>
  );
}
